import { constants as C } from '@bingads-webui-campaign-react/image-experience-model';

function validateCropSettings({
  tag,
  originalImage,
  cropSettings,
  minWidth,
  minHeight,
  aspectRatio,
  logger,
  isExpandedImage = false,
}) {
  if (originalImage.width < cropSettings.SourceWidth) {
    logger.trace(`${tag} provided invalid cropsettings for ${aspectRatio} originalWidth:${originalImage.width} ${tag}CropWidth:${cropSettings.SourceWidth} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (originalImage.height < cropSettings.SourceHeight) {
    logger.trace(`${tag} provided invalid cropsettings for ${aspectRatio} originalHeight:${originalImage.height} ${tag}CropHeight:${cropSettings.SourceHeight} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceHeight < 0) {
    logger.trace(`${tag} provided invalid SourceHeight ${cropSettings.SourceHeight} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceWidth < 0) {
    logger.trace(`${tag} provided invalid SourceWidth ${cropSettings.SourceWidth} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceX < 0) {
    logger.trace(`${tag} provided invalid X ${cropSettings.SourceX} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceY < 0) {
    logger.trace(`${tag} provided invalid Y ${cropSettings.SourceY} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceX + cropSettings.SourceWidth > originalImage.width) {
    logger.trace(`${tag} dimensions exceed width of image: CropX: ${cropSettings.SourceX} CropWidth: ${cropSettings.SourceWidth} ImageWidth: ${originalImage.width} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (cropSettings.SourceY + cropSettings.SourceHeight > originalImage.height) {
    logger.trace(`${tag} dimensions exceed height of image: CropY ${cropSettings.SourceY} CropHeight: ${cropSettings.SourceHeight} ImageWidth: ${originalImage.height} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (minWidth && minWidth > cropSettings.SourceWidth) {
    logger.trace(`${tag} width does not meet minWidth: CropWidth: ${cropSettings.SourceWidth} MinWidth: ${minWidth} imageSrc:${originalImage.Src}`);
    return false;
  }

  if (minHeight && minHeight > cropSettings.SourceHeight) {
    logger.trace(`${tag} height does not meet minHeight: CropHeight: ${cropSettings.SourceHeight} MinHeight: ${minHeight} imageSrc:${originalImage.Src}`);
    return false;
  }

  const tolerance = 0.01;
  if (!isExpandedImage && Math.abs((cropSettings.SourceWidth / cropSettings.SourceHeight) - (originalImage.width / originalImage.height)) < tolerance) {
    logger.trace(`${tag} target aspect ratio equal to the origin image aspect ratio: CropHeight: ${cropSettings.SourceHeight}  CropWidth: ${cropSettings.SourceWidth} OriginHeight: ${originalImage.height} OriginWidth:${originalImage.width} imageSrc:${originalImage.Src}`);
    return false;
  }

  return true;
}

export function validateSmartCropSettings({
  originalImage,
  cropSettings,
  minWidth,
  minHeight,
  aspectRatio,
  smartCropActivity,
}) {
  return validateCropSettings({
    tag: 'Smart crop',
    originalImage,
    cropSettings,
    minWidth,
    minHeight,
    aspectRatio,
    logger: smartCropActivity,
  });
}

export function validateExpandedCropSettings({
  imageExpansionType,
  expandedImageWidth,
  expandedImageHeight,
  expandedImageUrl,
  cropSettings,
  aspectRatio,
  minWidth,
  minHeight,
  logger,
}) {
  // if it's None, means the new image cropping data is not available
  // will fallback to use the original image cropping data (smart crop)
  if (imageExpansionType === C.ImageExpansionType.None) {
    return true;
  }
  const originalImage = {
    width: expandedImageWidth,
    height: expandedImageHeight,
    Src: expandedImageUrl,
  };

  if (!expandedImageWidth || !expandedImageHeight) {
    logger.trace(`invalid expanded image dimensions: width: ${expandedImageWidth} height: ${expandedImageHeight}`);
    // can't recover from this error
    throw new Error(`invalid expanded image dimensions: width: ${expandedImageWidth} height: ${expandedImageHeight}`);
  }

  return validateCropSettings({
    tag: `ImageFitting[${imageExpansionType}]`,
    originalImage,
    cropSettings,
    minWidth,
    minHeight,
    aspectRatio,
    logger,
    isExpandedImage: true,
  });
}
